import { Clickable, Icon, Row } from 'components';

const BackButton = ({ handleBack }) => {
  return (
    <Clickable onClick={handleBack}>
      <Row centerAll wid="30px" ht="30px" hasBorder="2px solid #000" hasRadius="40px">
        <Icon type="arrowLeft" dimensions={14} />
      </Row>
    </Clickable>
  );
};

export default BackButton;
